import styled, { css } from "styled-components";
import { bucketImageSource } from "assets/bucketImages";
const AppNames = ["live", "fan", "bio", "admin"] as const;
export type AppName = (typeof AppNames)[number];

interface PageHeaderImageProps extends React.HTMLAttributes<HTMLDivElement> {
  app?: AppName | "default";
  isExtended?: boolean;
}

export const PageHeaderImage = ({
  app = "default",
  isExtended,
  ...props
}: PageHeaderImageProps) => (
  <HeaderImage
    {...props}
    isExtended={isExtended}
    image={bucketImageSource.header[app]}
  />
);

type HeaderImageProps = { isExtended?: boolean; image?: string };

const HeaderImage = styled.div<HeaderImageProps>`
  width: 100%;
  height: 205px;
  position: absolute;
  z-index: -1;
  background: ${({ theme, image }) =>
      theme.custom?.layout?.content?.backgroundHeader?.background ||
      `url(${image})`}
    no-repeat left top;
  background-size: cover;

  ${({ isExtended }) =>
    isExtended &&
    css`
      height: 300px;
    `};

  ${({ theme }) => theme.media.mobile} {
    height: 142px;

    ${({ isExtended }) =>
      isExtended &&
      css`
        height: 178px;
      `};
  }
`;
